/**
 * The emoji the reply box offers.
 *
 * A short, fixed list rather than a picker library: a full picker is several
 * times the size of this whole console for the sake of characters every
 * operating system can already type (Win + . / ⌃⌘Space). These are the ones a
 * support reply actually uses, one click away.
 */
export const EMOJI: readonly string[] = [
  "🙂", "😊", "😀", "😄", "😅", "😂", "😉", "😍",
  "🤔", "😕", "😔", "😢", "😮", "😎", "🙏", "👍",
  "👎", "👌", "👏", "🙌", "💪", "🤝", "👋", "✌️",
  "❤️", "🎉", "🔥", "⭐", "✅", "❌", "⚠️", "❓",
  "❗", "💡", "🔧", "🔒", "🔑", "📎", "📷", "📧",
  "⏳", "🕐", "🚀", "💬", "👀", "🎮", "💳", "🛒",
];

/** The text with `insert` placed at the caret, and where the caret ends up. */
export function insertAt(text: string, caret: number, insert: string): { text: string; caret: number } {
  const at = Math.max(0, Math.min(caret, text.length));
  return { text: text.slice(0, at) + insert + text.slice(at), caret: at + insert.length };
}
